<template>
  <AppPageContainer :showNav="true" :clean="true" :background="'calendar'">
    <div class="statistics">
      <div class="statistics--bar">
        <div class="statistics--sections">
          <div class="statistics--sections--tab">Overview</div>
          <div class="statistics--sections--tab">Sessions</div>

          <!-- All Insights -->
          <div class="statistics--sections--tab">Insights</div>
          <div class="statistics--sections--tab">People</div>
          <div class="statistics--sections--tab">Leaderboard</div>
          <div class="statistics--sections--tab">Attendance</div>

          <!-- <div class="statistics--sections--tab">Referrals</div> -->
        </div>
        <div class="statistics--toggles">
          <div class="statistics--toggle" :class="isSelected('days')" @click="setConfig('days')">Day View</div>
          <div class="statistics--toggle" :class="isSelected('weeks')" @click="setConfig('weeks')">Week View</div>
          <div class="statistics--toggle" :class="isSelected('months')" @click="setConfig('months')">Month View</div>
        </div>
      </div>
      <div class="statistics--widget">
        <div class="statistics--widget--graph">
          <ELYXLineChart :filteredData="getChartData" />
        </div>
      </div>
    </div>
  </AppPageContainer>
</template>

<script>
import AppPageContainer from "../../components/AppPageContainer.vue";
import ELYXLineChart from "../../ELYXComponents/ELYXLineChart.vue";
import StatisticsMethods from "./StatisticsMethods";

export default {
  components: {
    ELYXLineChart,
    AppPageContainer,
  },

  mounted() {
    this.getStatsInRange();
  },

  computed: {
    getChartData() {
      return { chartData: this.chartData, options: this.chartOptions, graphOptions: this.graphOptions };
    },
  },

  data() {
    return {
      config: "months",

      chartData: {
        labels: [],
        datasets: [
          {
            label: "Sessions done that month",
            data: [],
            fill: false,
            borderColor: "#2554FF",
            backgroundColor: "#2554FF",
            borderWidth: 1,
            maxWidth: "700px",
          },
        ],
      },

      graphOptions: {
        bothJoined: false,
        startDate: null,
        endDate: null,
        view: "1D",
      },

      chartOptions: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },

  methods: {
    async getStatsInRange() {
      const graphData = await StatisticsMethods.getStatsInRange(this.config);

      const label = this.changeGraphLabel(this.config);

      const newObj = {
        labels: graphData.labels,
        datasets: [
          {
            label,
            data: graphData.datasets,
            fill: false,
            borderColor: "#2554FF",
            backgroundColor: "#2554FF",
            borderWidth: 1,
          },
        ],
      };

      this.chartData = newObj;
    },
    async setConfig(view) {
      this.config = view;
      await this.getStatsInRange();
    },
    isSelected(view) {
      return this.config === view ? "statistics--toggleSelected" : "";
    },
    changeGraphLabel(config) {
      let label = "Sessions done that ";
      if (config === "days") {
        label += "day";
      } else if (config === "months") {
        label += "month";
      } else if (config === "weeks") {
        label += "week";
      }
      return label;
    },
  },
};
</script>

<style>
.statistics {
  width: 1200px;
  margin: 0px auto;
  padding-top: 30px;
}
.statistics--bar {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.statistics--toggles {
  display: flex;
  margin-left: auto;
}
.statistics--toggle {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  height: 28px;
  color: rgb(247, 248, 248);
  backdrop-filter: blur(12px);
  font-size: 13px;
  font-weight: 500;
  line-height: 28px;
  white-space: nowrap;
  padding: 0px 12px;
  background: rgba(15, 15, 15);
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.05);
  border-image: initial;
  border-radius: 360px;
  transition: background 260ms ease 0s, width;
  animation: 1200ms ease 0ms 1 normal backwards running gisjuz;
  cursor: pointer;
  margin: 0px 2px;
}
.statistics--toggle:hover {
  background-color: rgb(52, 52, 52);
}
.statistics--toggleSelected {
  background-color: #2554ff;
  color: white;
}
.statistics--sections {
  display: flex;
}
.statistics--sections--tab {
  margin: 0 10px;
}

.statistics--widget {
  background-color: rgb(255 255 255 / 80%);
  border-radius: 16px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  max-width: 700px;
  padding: 10px;
  padding-top: 5px;
  box-sizing: border-box;
}
.statistics--widget--graph {
}
</style>
